import { render, staticRenderFns } from "./modalOpcionesProducto.vue?vue&type=template&id=68700dbc&scoped=true"
import script from "./modalOpcionesProducto.vue?vue&type=script&lang=js"
export * from "./modalOpcionesProducto.vue?vue&type=script&lang=js"
import style0 from "./modalOpcionesProducto.vue?vue&type=style&index=0&id=68700dbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68700dbc",
  null
  
)

export default component.exports